'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a button which submits the form it's in.
 * @extends {Component}
 */
var SubmitButtonComponent = function (_React$Component) {
  _inherits(SubmitButtonComponent, _React$Component);

  function SubmitButtonComponent() {
    _classCallCheck(this, SubmitButtonComponent);

    return _possibleConstructorReturn(this, (SubmitButtonComponent.__proto__ || Object.getPrototypeOf(SubmitButtonComponent)).apply(this, arguments));
  }

  _createClass(SubmitButtonComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _reactBootstrap.Button,
        {
          bsStyle: 'primary',
          className: 'ingle-form-submit-button button',
          type: 'submit',
          disabled: this.props.isFormSubmitting || this.props.isFormInvalid,
          onClick: this.props.showErrors
        },
        function () {
          if (_this2.props.isFormSubmitting) {
            return _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_reactBootstrap.Glyphicon, {
                glyph: 'refresh',
                className: 'glyphicon-refresh-animate'
              }),
              ' ',
              _this2.props.submittingText
            );
          }

          return _this2.props.children;
        }()
      );
    }
  }]);

  return SubmitButtonComponent;
}(_react2.default.Component);

SubmitButtonComponent.propTypes = {
  isFormSubmitting: _react2.default.PropTypes.bool.isRequired,
  isFormInvalid: _react2.default.PropTypes.bool.isRequired,
  submittingText: _react2.default.PropTypes.string,
  children: _react2.default.PropTypes.string.isRequired,
  showErrors: _react2.default.PropTypes.func
};
SubmitButtonComponent.defaultProps = {
  submittingText: (0, _translate.t)('Submitting') + '...'
};
exports.default = SubmitButtonComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/SubmitButtonComponent.jsx
// module id = 270
// module chunks = 0